import React, { memo, ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

export interface IWrongCountryProductProps {
  productName: string;
  countryName: string;
  children?: ReactNode;
}

const WrongCountryProduct = ({ productName, countryName, children }: IWrongCountryProductProps): JSX.Element => (
  <Box textAlign="center">
    <Typography className="H4-Dark-Bold">
      The {productName} does not ship to {countryName}
    </Typography>
    <Box mt={2} mb={1}>
      {children}
    </Box>
  </Box>
);

export default memo<IWrongCountryProductProps>(WrongCountryProduct);
